import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import DropdownComponent from "../../../../../components/UI_Kit/Dropdown/Dropdown";

// Helper to generate a unique and valid controlId from the field name
const generateControlId = (fieldName) => {
  return fieldName.replace(/\s+/g, '-').toLowerCase(); // e.g., "type-du-support"
};

const TypeThreeForm = ({ // Renamed component
  config, // Added config prop
  type3Data,
  handleChange,
  fileInputRef,
  handlePhotoUpload,
  showMenu,
  setShowMenu,
  handleOpenModal,
  handleDeletePhoto,
}) => {

  // Mapping from config field names to state keys in type3Data
  const fieldNameToStateKeyMap = {
    "Type du support": "supportType",
    "Type de Liaison": "installationType",
    "Type d'Alimentation": "powerSupplyType",
    // Add other mappings if high_point has different/more fields in config
    // Note: "Zone de couverture" is handled separately below
  };

  return (
    <>
      {/* Point Name - Remains unchanged */}
      <Row >
        <Col>
          <Form.Group controlId="pointName">
            <Form.Label>Nom du point</Form.Label>
            <Form.Control
              name="pointName"
              value={type3Data.pointName}
              onChange={handleChange}
              placeholder="Nommer le point"
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Location/Photos - Remains unchanged */}
      <Row className="mb-4 mt-4">
        <Col>
          <Form.Group controlId="location">
            <Form.Label>Localisation*</Form.Label>
            <div
              className="photo-upload-box"
              onClick={() => fileInputRef.current.click()}
            >
              <span className="photo-upload-placeholder">
                <img src="/camera.png" alt="Camera"></img> Ajouter une photo
              </span>
            </div>
            <Form.Control
              ref={fileInputRef}
              type="file"
              name="photo"
              accept="image/*"
              onChange={handlePhotoUpload}
              multiple
              hidden
            />
          </Form.Group>

          <div className="photo-preview-list">
            {type3Data.photos?.map((photo, index) => (
              <div key={index} className="photo-preview-item">
                <div className="photo-preview-image-container">
                  <img
                    src={photo.url}
                    alt="Uploaded"
                    className="photo-preview-image"
                  />
                </div>
                <div className="photo-details">
                  <strong className="photo-title">
                    Localisation_Vue {index + 1}
                  </strong>
                  <span className="photo-name">
                    <img src="/picture.png" className="location-icon" alt="PIC NAME"></img>{" "}
                    {/* Limit photo name to 10 characters and add ellipsis if truncated */}
                    {photo.name ? (photo.name.length > 10 ? photo.name.substring(0, 10) + '...' : photo.name) : ''}
                  </span>
                  <span className="photo-meta">
                    <img src="/location.png" className="location-icon" alt="PIC METADATA"></img>{" "}
                    {/* Limit photo location to 20 characters and add ellipsis if truncated */}
                    {photo.location ? (photo.location.length > 20 ? photo.location.substring(0, 20) + '...' : photo.location) : "Pas de localisation"}
                  </span>
                </div>
                <div className="photo-actions">
                  <span
                    className="photo-options-btn"
                    onClick={() =>
                      setShowMenu(showMenu === index ? null : index)
                    }
                  >
                    ⋮
                  </span>
                  {showMenu === index && (
                    <div className="custom-dropdown-menu">
                      <div className="dropdown-arrow" />
                      <button
                        className="custom-dropdown-item"
                        onClick={() => {
                          handleOpenModal(index);
                          setShowMenu(null);
                        }}
                      >
                        <img src="/edit_alt.png" className="action-icon"></img> {" "}
                        Modifier
                      </button>
                      <button
                        className="custom-dropdown-item"
                        onClick={() => {
                          handleDeletePhoto(index);
                          setShowMenu(null);
                        }}
                      >
                        <img src="/close.png" className="action-icon"></img> {" "}
                        Supprimer
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>

      {/* Dynamically generated select fields */}
      {config?.fields && Object.entries(config.fields).map(([fieldName, options]) => {
        const stateKey = fieldNameToStateKeyMap[fieldName];
        const controlId = generateControlId(fieldName);

        // Only render if we have a mapping for the field name to a state key
        // or if the fieldName is "Zone de couverture" which has its own state key
        if (!stateKey && fieldName !== "Zone de couverture") {
          console.warn(`No state key mapping found for config field: ${fieldName} in TypeThreeForm`);
          return null; // Skip rendering this field
        }

        // Use 'coverageArea' as stateKey for "Zone de couverture"
        const currentName = fieldName === "Zone de couverture" ? "coverageArea" : stateKey;
        const currentValue = fieldName === "Zone de couverture" ? type3Data.coverageArea : type3Data[stateKey];

        return (
          <Row className="mb-3" key={controlId}>
            <Col>
              <Form.Group controlId={controlId}>
                <Form.Label>{fieldName}*</Form.Label> {/* Use fieldName as label */}
                <DropdownComponent
                  name={currentName} // Use the mapped state key or 'coverageArea'
                  value={currentValue} // Access value using the mapped state key or 'coverageArea'
                  onChange={handleChange}
                  options={options}
                  placeholder="Sélectionner..."
                />
              </Form.Group>
            </Col>
          </Row>
        );
      })}

      {/* Coverage Area - Remains specific to this form - THIS SECTION CAN NOW BE REMOVED IF "Zone de couverture" is always in config.fields */}
      {/* 
      <Row className="mb-3">
        <Col>
          <Form.Group controlId="coverageArea">
            <Form.Label>Zone de couverture*</Form.Label>
            <Form.Control
              name="coverageArea"
              value={type3Data.coverageArea}
              onChange={handleChange}
              placeholder="Définir la zone de couverture"
              required
            />
          </Form.Group>
        </Col>
      </Row>
      */}

      {/* Comment  */}
      <Row >
        <Col>
          <Form.Group controlId="comment">
            <Form.Label>Commentaire</Form.Label>{" "}
            <Form.Control
              as="textarea"
              name="comment"
              value={type3Data.comment}
              onChange={handleChange}
              placeholder="Ajouter un commentaire..."
              maxLength={300}
              className="comment-box"
            />
            <div className="char-counter">{type3Data.comment?.length || 0}/300</div>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default TypeThreeForm; // Updated export name
